module.exports = __webpack_public_path__ + "img/terms.68f8f501.svg";